import { Hidden } from "@material-ui/core";
import BasicCrudActionsLayout from "../screenTypes/layout/BasicCrudActionsLayout";
import FlexCrudScreenHeaderLayout from "../screenTypes/layout/FlexCrudScreenHeaderLayout";
import FlexCrudScreenTypeLayout from "../screenTypes/layout/FlexCrudScreenTypeLayout";
import ToolbarFlexSpacer from "../layout/ToolbarFlexSpacer";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import CustomRecordButton from "../input/CustomRecordButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";
import SaveToExcelButton from "../input/SaveToExcelButton";
import AutoForm from "../form/functional/AutoForm";
import { useEffect, useState } from "react";
import getSchema from "../../lib/api/getSchema";
import getSpecific from "../../lib/api/getSpecific";
import { cloneDeep } from 'lodash';


function KonamAutoFormScreen(props) {

    const {
        isCreate,
        isDelete,
        select,
        view,
        table,
        refresh,

        grid,

        onSuccess,
        onFailure,

        checkDisabledCallback,
        modifyFormDataCallback
    } = props;

    const [schema, setSchema] = useState();
    const [screenSchema, setScreenSchema] = useState();

    const [initData, setInitData] = useState({ selectedItems: [] });

    useEffect(() => {
        let mounted = true;
        (async () => {
            let schema = await getSchema(table);

            if (mounted) {
                setSchema(schema);
            }
            let screenSchema = cloneDeep(schema);

            for (let column of screenSchema.columns) {
                switch (column.name) {
                    case "materialCode":
                    case "materialCodeVer":
                        // case "qtySafetyStock":
                        column.hideInForm = true;
                        break;
                    default:
                        break;
                }
            }

            for (let column of screenSchema.columns) {
                column.required = false;
            }
            if (mounted) {
                setScreenSchema(screenSchema)
            }
        })();

        return (() => {
            mounted = false;
        });
    }, [table]);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                let result = await getSpecific(`${table}/${select?.materialCode}/${select?.materialCodeVer}`)

                let initData = {};
                initData.selectedItems = [];
                initData.selectedItems.push({
                    materialCode: select?.materialCode,
                    materialCodeVer: select?.materialCodeVer,
                    ...(result)
                })
                if (mounted) {
                    setInitData(initData)
                }
            } catch (reason) {
                if (mounted) {
                    setInitData({ selectedItems: [] })
                }
            }
        })();
        return (() => {
            mounted = false;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [table]);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                let result = await getSpecific(`${table}/${select?.materialCode}/${select?.materialCodeVer}`)

                let initData = {};
                initData.selectedItems = [];
                initData.selectedItems.push({
                    materialCode: select?.materialCode,
                    materialCodeVer: select?.materialCodeVer,
                    ...(result)
                })
                if (mounted) {
                    setInitData(initData)
                }
            } catch (reason) {
                if (mounted) {
                    setInitData({ selectedItems: [] })
                }
            }
        })();
        return (() => {
            mounted = false;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [select]);

    const updateSuccess = async (data) => {

        if (refresh) {
            refresh.refresh();
        }

        if (onSuccess) {
            onSuccess(data);
        }

        try {
            let result = await getSpecific(`${table}/${select?.materialCode}/${select?.materialCodeVer}`)

            let initData = {};
            initData.selectedItems = [];
            initData.selectedItems.push({
                materialCode: select?.materialCode,
                materialCodeVer: select?.materialCodeVer,
                ...(result)
            })

            setInitData(initData)

        } catch (reason) {

            setInitData({ selectedItems: [] })

        }

    }

    return (
        <FlexCrudScreenTypeLayout>
            <FlexCrudScreenHeaderLayout className="basicCrudScreenHeaderLayout">
                <BasicCrudActionsLayout className="basicCrudScreenActionsLayout">
                    <Hidden smDown>
                        <ToolbarFlexSpacer xs />
                        <BasicCrudScreenActionItemLayout >
                            {isCreate ? <AccessControl
                                accessTarget={schema && schema.name}
                                accessMethod={
                                    schema &&
                                    (schema.updateWithPatch ? "PATCH" : "PUT")
                                }
                            >
                                <CustomRecordButton
                                    id={table}
                                    schema={schema}
                                    onSuccess={updateSuccess}
                                    buttonFullName="buttonName.create"
                                    checkDisabledCallback={checkDisabledCallback}
                                    modifyFormDataCallback={modifyFormDataCallback}
                                    mode="create"
                                    title="create"
                                />
                            </AccessControl> : <></>}
                            <AccessControl
                                accessTarget={schema && schema.name}
                                accessMethod={
                                    schema &&
                                    (schema.updateWithPatch ? "PATCH" : "PUT")
                                }
                            >
                                <UpdateRecordButton
                                    grid={initData}
                                    schema={schema}
                                    onSuccess={updateSuccess}
                                    disabled={!select?.materialCode}
                                />
                            </AccessControl>
                            {
                                isDelete ? <AccessControl
                                    accessTarget={schema && schema.name}
                                    accessMethod="DELETE"
                                >
                                    <DeleteRecordButton
                                        onSuccess={updateSuccess}
                                        onFailure={onFailure}
                                        grid={grid ? grid : {}}
                                        schema={schema}
                                        color="secondary"
                                        disabled={!select?.materialCode}

                                    />
                                </AccessControl> : <></>
                            }
                        </BasicCrudScreenActionItemLayout>
                    </Hidden>
                </BasicCrudActionsLayout>
            </FlexCrudScreenHeaderLayout>
            <div className="basicCrudScreenContentLayout">

                <AutoForm
                    schema={screenSchema}
                    mode={"edit"}
                    initialData={{ ...(initData?.selectedItems[0]) }}
                    checkDisabledCallback={() => true}
                    onChange={() => { }}
                />
            </div>
        </FlexCrudScreenTypeLayout>
    )
}

export default KonamAutoFormScreen;